<template>
  <x-page title="确认收货">
    <x-result
      title="确认收货成功"
      confirm-text="立即评价"
      guess-resource-position-id="8aaa8b7b79f3a40d017a0f0700820108"
      :confirm-track="{
        name: '确认收货-立即评价',
        id: '09693ad2-07dd-48a8-86e4-2cb940d90a0c',
      }"
      @confirm="handleConfirmClick"
    />
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { mapQuery, Track } from '@/utils'
  import { redirectTo } from '@/router'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      mapQuery({
        // 订单编号
        orderNo: 'orderNo',
      }),
      Track.provideMark(() => ({
        page: '确认收货成功',
      })),
    ],

    methods: {
      // 点击立即评价
      handleConfirmClick() {
        redirectTo('OrderComment', {
          orderNo: this.orderNo,
        })
      },
    },
  })
</script>

<style lang="scss" scoped></style>
